import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

const parseReference = reference => {
  if (!reference) return
  let [onModel, ref] = reference.split(':')
  return { onModel, ref }
}

const PropsHandler = route => {
  return {
    collection: route.query.collection,
    config: route.query.config,
    returnTo: route.query.returnTo,
    reference: parseReference(route.query.reference),
    ...route.params,
  }
}

export default [
  {
    name: 'post-create',
    path: '/post/create',
    props: PropsHandler,
    component: () => LazyLoadView(import(/* webpackChunkName: "post" */ '@/views/Post/Mutate')),
    meta: {
      breadcrumb: ({ $route: route }) => {
        let [onModel, ref] = route.query.reference.split(':')
        return { onModel, ref }
      },
    },
    beforeEnter: isAuthenticated,
  },
  {
    name: 'post-edit',
    path: '/post/:id',
    props: PropsHandler,
    meta: {
      breadcrumb: ({ $route: route }) => {
        let [onModel, ref] = route.query.reference.split(':')
        return { onModel, ref }
      },
    },
    component: () => LazyLoadView(import(/* webpackChunkName: "post" */ '@/views/Post/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
]
